// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-module--avatar--b4f80","placeholder":"Avatar-module--placeholder--598b4"};